import { queryMaterialProductPageList, } from "@/api/promote";
import loadLeft from "@/assets/load_left.png";
import loadRight from "@/assets/load_right.png";
import loadingPng from "@/base64";
import exposure from "@/utils/expose/exposure";
import { getCookie } from "@/utils/platform";
import { pxtorem } from "@/utils/pxtorem";
import { ProductModel } from "@akc/biz-api";
// import { ProductCard12DiscoverComp } from "@akc/mx-taro-h5-components";
import { InfiniteScroll, PullToRefresh } from "antd-mobile";
import { sleep } from "antd-mobile/es/utils/sleep";
import Macy from "macy";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useActivate } from "react-activation";
import { useNavigate, useSearchParams } from "react-router-dom";
import useShare from "../../share";
import { useTrack } from "../../track";
import Category, { ListEntity } from "../category";
import MaterialProductCard from "./components/MaterialProductCard";
import styles from "./index.module.less";
interface DiscoveryProps {
  // 逛一逛的当前tab,1为发现，2为推荐,
  activeTab: string;
}

// 封面图片信息map，key是图片url, value是图片信息，包括宽高等
const imageInfoMap = new Map();

/**
 * 推广-发现
 */
const Discovery: React.FC<DiscoveryProps> = React.memo((props: DiscoveryProps) => {
  const { activeTab } = props;
  const navigate = useNavigate();
  const [macyObject, setMacyObject] = useState<any>({});
  const [materialDatalist, setMaterialDatalist] = useState<any>([]);
  const pageNumRef = useRef<number>(1);
  const [isEmpty, setIsEmpty] = useState<boolean>(false);
  // 当前tab下的内容是否正在加载中
  const [isloading, setIsloading] = useState<boolean>(false);
  const [hasNext, setHasNext] = useState<boolean>(false);
  const frontCodesRef = useRef<ListEntity | null>(null);
  const [search] = useSearchParams();
  const objectIds = search.get("objectIds");
  const baseProductIds = search.get("baseProductIds");
  const distributorId = search.get("distributorId");
  const shopId = search.get("shopId");
  const [firstLoaded, setFirstLoaded] = useState<boolean>(false);
  const [canLoadMore, setCanLoadMore] = useState<boolean>(true);
  const { trackDiscoveryCardClick } = useTrack();
  const useShareProps = useShare();
  let searchRequestIdRef = useRef("");
  // 跟isloading寓意重复，可以删除
  const loadRef = useRef(false);

  // useEffect(() => {
  //   searchRequestIdRef.current = (getCookie("mstoken") || "") + Date.now();
  //   // console.log("searchRequestId", searchRequestId);
  // }, []);

  const onChosenLabelItem = (item: ListEntity) => {
    searchRequestIdRef.current = (getCookie("mstoken") || "") + Date.now();
    // 更新当前类目
    frontCodesRef.current = item;
    queryMaterialList(item,true);
  };

  const reset = () => {
    if (activeTab === "1") {
      // 发现tab
      setCanLoadMore(true);
      // 配置系统分享
      useShareProps.shareSetting(2, null, null);
      if (macyObject["waterfall"]) {
        macyObject["waterfall"].recalculate(true, true);
      }    
    } else {
      // 推荐tab,此时发现面板只是不可见，并未销毁
      setCanLoadMore(false);
    }
  };

  useEffect(() => {
    reset();
  }, [activeTab]);


  // macy实现瀑布流(这里不是用的src/components/waterfall/index.tsx实现)
  useLayoutEffect(() => {
    if (materialDatalist?.length > 0) {
      const interval = setInterval(() => {
        const dom = document.getElementById("waterfall");
        if (dom) {
          clearInterval(interval);
          const macyInstance = Macy({
            container: "#waterfall", // 容器元素的选择器
            trueOrder: false, // 优先平衡列高而非严格遵循HTML顺序
            waitForImages: true, // 等待图片加载完成后再布局
            useOwnImageLoader: false, // 使用Macy自己的图片加载器
            debug: true, // 开启调试模式
            margin: { x: 0, y: 15 }, // 设计列与列的间距
            columns: 2, // 设置列数
          });
          macyObject["waterfall"] = macyInstance;
          setMacyObject(macyObject);
          // setTimeout(() => {
          macyObject["waterfall"].runOnImageLoad(function () {
            macyObject["waterfall"].recalculate(true, true);
            setFirstLoaded(true);
          });
          let sessionStorageValue: string = sessionStorage.getItem("discovery_card_12") as string;
          sessionStorageValue = JSON.parse(sessionStorageValue);
          const objName = "waterfall";
          if (sessionStorageValue) {
            sessionStorageValue[objName] = document.getElementById(objName)?.style.height;
            sessionStorage.setItem("discovery_card_12", JSON.stringify(sessionStorageValue));
          } else {
            const obj: any = {};
            obj[objName] = document.getElementById(objName)?.style.height;
            sessionStorage.setItem("discovery_card_12", JSON.stringify(obj));
          }
          // }, 50);
        }
      }, 50);
    }
  }, [materialDatalist?.length]);

  // 点击素材商品卡片，跳转商品视频大卡页
  const goDetail = (item:ProductModel, index) => {
    const indexAll = (pageNumRef.current - 1) * 10 + index;
    trackDiscoveryCardClick({
      item,
      btn_name: "查看详情",
      index: indexAll,
      tab_name: frontCodesRef.current?.name,
      searchRequestId:searchRequestIdRef.current,
    });
  };


  // 商卡点赞
  const setLike = async (item: ProductModel,oldIsFollow: boolean, index: number) => {
    trackDiscoveryCardClick({
      item,
      btn_name: oldIsFollow ? "取消收藏" : "收藏",
      index: (pageNumRef.current - 1) * 10 + index,
      tab_name: frontCodesRef.current?.name,
      searchRequestId:searchRequestIdRef.current,
    });
  };

  /**
   * 分析图片尺寸信息
   * @param list 
   * @returns 
   */
  const queryImageInfo = async (list: Array<any>) => {
    /**
     * 解析图片宽高尺寸等信息
     * @param url 
     * @returns 
     */
    const queryInfo = (url="") => {
      return new Promise(resolve => {
        if (imageInfoMap.get(url)) {
          console.log("imageInfoMap", imageInfoMap.size);
          resolve(imageInfoMap.get(url));
        } else if (url.indexOf("?") === -1) {
          // 查询图片宽高
          fetch(url + "?x-image-process=image/info")
            .then(res => {
              if (res.status === 200) {
                return res.json();
              }
            })
            .then(res => {
              imageInfoMap.set(url, res);
              resolve(res);
            })
            .catch(() => {
              console.log("img error");
              resolve({ width: "", height: "" });
            });
        } else {
          resolve({ width: "", height: "" });
        }
      });
    };
    const promises = list.map(product => {
      const containVideo=product?.productVideoCardVO?.type ===  "VIDEO";
      const mainPicUrl = containVideo ? product?.productVideoCardVO?.videoCover : product?.productVideoCardVO?.imgUrls?.[0];
      return queryInfo(mainPicUrl || "");
    });
    const dimensionsList = await Promise.all(promises);
    return list.map((item, index) => {
      return {
        ...item,
        coverInfo: dimensionsList[index],//封面图尺寸信息，卡片内用到
      };
    });
  };

  // 查询素材商品
  const queryMaterialList = async (item?: ListEntity | null, init?: boolean) => {
    // 这里不做loading中判断，因为类目切换时，会存在并发的场景，接口响应后，会丢弃老类目的数据
    setIsEmpty(false);
    if (init) {
      pageNumRef.current = 1;
      setMaterialDatalist([]);
      setFirstLoaded(false);
      setHasNext(false); // 防止 InfiniteScroll 触发 loadMore 导致重复请求
      const dom = document?.getElementById("discovery-wrapper");
      if (dom) {
        dom.scrollTop = 0;
      }
    }
    setIsloading(true);

    const params = {
      scene: "G_P_C",
      pageNo: pageNumRef.current,
      pageSize: 10,
      frontCodes: [item] ,
      searchRequestId: searchRequestIdRef.current,
      objectIds: objectIds?.split(","),
      baseProductIds: baseProductIds?.split(","),
      queryType: search.get("queryType") ?? undefined,
    };
    objectIds?.length ? (params.scene = "") : void 0; // 实拍专区不需要该标识
    
    // 保存请求时的类目 type，用于检测类目切换
    const requestCategoryCode = params.frontCodes[0]?.code;
    
    try {
      const res = await queryMaterialProductPageList(params);
      
      // 如果请求期间，切换了类目，则丢弃这次查询结果
      if (frontCodesRef.current?.code!==undefined &&requestCategoryCode !== frontCodesRef.current?.code) {
        console.error("类目已切换，丢弃旧的查询结果",params.frontCodes[0],frontCodesRef.current);
        return;
      }
      setIsloading(false);
      if (res && res.data) {
        if (res.data.totalCount === 0) {
          setFirstLoaded(true);
          setTimeout(() => {
            setHasNext(false);
            setIsEmpty(true);
          }, 300);
          return;
        }
        setTimeout(() => {
          setHasNext(res.data.hasNext);
        }, 300);
        if (res.data.result && res.data.result.length > 0) {
          setIsEmpty(false);
          const handledData = await queryImageInfo(res.data.result);
          if (init) {
            setMaterialDatalist(handledData);
          } else {
            setMaterialDatalist([...materialDatalist, ...handledData]);
          }
          pageNumRef.current = pageNumRef.current + 1;
        }
      }
      if (init) {
        setTimeout(() => {
          setFirstLoaded(true);
        }, 2000);
      }
    } catch (error) {
      setIsloading(false);
      console.error(error);
      if (init) {
        setIsEmpty(true);
        if (init) {
          setTimeout(() => {
            setFirstLoaded(true);
          }, 2000);
        }
      }
    }
  };
  //发现页素材商品卡片曝光埋点
  useEffect(() => {
    const interval = setInterval(() => {
      let flag = false;
      for (let i = 0; i < materialDatalist.length; i++) {
        const dom = document.getElementById(`discovery-${materialDatalist[i].activitySpuId}`);
        if (dom) {
          exposure.add({
            el: dom,
          });
        } else {
          flag = true;
        }
        if (!flag) {
          clearInterval(interval);
        }
      }
    }, 1000);
  }, [materialDatalist?.length]);

  // 会默认执行一次
  const loadMore = async () => {
    // 如果 pageNo=1 且数据为空，说明正在初始化，不执行 loadMore
    if (pageNumRef.current === 1 && materialDatalist.length === 0) {
      return;
    }
    if (canLoadMore && hasNext && !isloading) {
      await queryMaterialList(frontCodesRef.current,false);
    }
  };

  //加载更多
  const InfiniteScrollContent = ({ hasMore }: { hasMore?: boolean; }) => {
    return (
      <div className={styles.infinite}>
        {hasMore && isloading && materialDatalist.length > 0 ? (
          <div className={styles.loadingMore}>
            <img src={loadingPng} style={{ width: pxtorem(20), height: pxtorem(20) }} />
          </div>
        ) : (
          <div style={{ display: "flex", alignItems: "center" }}>
            {materialDatalist?.length > 0 && !hasMore && (
              <div className={styles.toEnd}>
                <img style={{ width: pxtorem(26), height: pxtorem(2) }} src={loadLeft}></img>
                <div style={{ color: "rgba(204, 204, 204, 1)" }}>已经到底了</div>
                <img style={{ width: pxtorem(26), height: pxtorem(2) }} src={loadRight}></img>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };
  return (
    <div
      className={styles["discovery-wrapper"]}
      style={{ paddingTop: pxtorem(88) }}
      id="discovery-wrapper">
      {/* 类目tabs */}
      <Category handleChosen={onChosenLabelItem} />

      {/* 空数据 */}
      {isEmpty && !isloading && (
        <div className={styles["empty-wrapper"]}>
          <img
            className={styles["empty-img"]}
            src="https://akim-oss.aikucun.com/39b4ba7e3b243ff2a354ee1d644cbac0a0a2c1ed_1700467176746_20.png"
          />
          <div className={styles["empty-text"]}>暂无数据</div>
        </div>
      )}

      {/* 骨架屏 */}
      {!firstLoaded && (
        <img
          className={styles["skeleton-img"]}
          src="https://akim-oss.aikucun.com/65a2747ad0c9358eaf813808668d3a493be6db9f_1700560940576_26.png"
        />
      )}

      {/* 素材feed流 */}
      <PullToRefresh
        onRefresh={async () => {
          await sleep(1000);
          queryMaterialList(frontCodesRef.current, true);
        }}>
        <div className={styles["water-fall-box"]}>
          {materialDatalist && materialDatalist?.length > 0 && (
            <div id="waterfall" className={styles["waterfall"]}>
              {materialDatalist.map((item, index) => {
                return (
                  <div
                    className={styles["card-item"]}
                    key={index}
                    id={`discovery-${item.activitySpuId}`}
                    data-param={JSON.stringify({
                      page_name: "种草社区_发现",
                      previous_page_name: "",
                      domain: "种草",
                      tabName: frontCodesRef.current?.name,
                      resourceRank: index,
                      type: "种草图文组件",
                      name: item?.showName,
                      materialId: item.materialNo,
                      resource_content: "商品",
                      recommend_requestid: searchRequestIdRef.current,
                      activity_spu_code: item.activitySpuId,
                    })}
                    data-eventid={`discovery-${item.activitySpuId}`}>
                    {/* 素材商品卡片，这里不换成taro统一的素材商品卡片组件 ProductCard12DiscoverComp，因为瀑布流下会有问题 */}
                    <MaterialProductCard
                      key={index}
                      product={item}
                      coverInfo={item.coverInfo}
                      setLike={(item,oldIsFollow) => {
                        setLike(item, oldIsFollow,index);
                      }}
                      goDetail={item => {
                        goDetail(item, index);
                      }}
                    />
                  </div>
                );
              })}
            </div>
          )}
          <InfiniteScroll loadMore={loadMore} hasMore={hasNext} threshold={250}>
            <InfiniteScrollContent hasMore={hasNext} />
          </InfiniteScroll>
        </div>
      </PullToRefresh>
    </div>
  );
});
export default Discovery;
